<template>
    <div>
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item style="float: right">
                <el-button size="small" @click="currentChangeHandle(1)">刷新参数列表</el-button>
                <el-button size="small" type="primary" @click="addOrUpdateHandle()">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                row-key="id"
                border
                stripe
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%"
        >

            <el-table-column
                    fixed
                    type="index"
                    align="center"
                    label="序号"
                    width="60"
                    :index="getRowsIndex"
            >
            </el-table-column>
            <el-table-column type="selection"  align="center" fixed width="55"></el-table-column>
            <el-table-column
                    fixed
                    header-align="center"
                    align="center"
                    width="150"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改</el-button>
                    <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
            <el-table-column
                    fixed
                    prop="code"
                    header-align="left"
                    align="left"
                    width="220"
                    label="数据集编号"
            >
            </el-table-column>

            <el-table-column
                    prop="hasMultiLine"
                    header-align="left"
                    align="left"
                    label="是否有多行数据"
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.hasMultiLine == true" size="small" type="small">是</el-tag>
                    <el-tag v-else size="small" type="danger">否</el-tag>
                </template>
            </el-table-column>


        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalCount"
                layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</template>

<script>
    import AddOrUpdate from './detail_config_dataset_edit.vue'

    export default {
        props: {
            formId: {
                type: String,
                required: true,
            },
        },
        components: {
            AddOrUpdate
        },
        data() {
            return {
                dataForm: {
                    searchKey: "",
                    formId: "",
                },
                datasourceTypeList: [],
                inputTypeList: ['text', 'select', 'datetime', 'number'],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                dataTypeList: [],
                dictCateList: [],
                pageIndex: 1,
                pageSize: 10,
                totalCount: 0,
                dataList: [],
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            };
        },
        activated() {

        },
        mounted() {
            this.dataForm.formId = this.formId;
            this.getDataList();
        },
        methods: {
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true;
                this.$httpReq({
                    url: "/customform/fromdataset/list",
                    method: "post",
                    baseURL:  process.env.VUE_APP_proxybaseurl + '',
                    data: {
                        filter: {
                            formId: this.dataForm.formId,
                        },
                        page: this.pageIndex,
                        rows: this.pageSize,
                        searchKey: this.dataForm.searchKey,
                    },
                }).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows;
                        this.totalCount = data.total;
                        this.pageIndex = data.pageIndex;
                    } else {
                        this.dataList = [];
                        this.totalCount = 0;
                        this.pageIndex = 1;
                    }
                    this.dataListLoading = false;
                });
            },

            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id, this.formId)
                })
            },
            // 删除
            deleteHandle(id) {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$httpReq({
                        url:'/customform/fromdataset/delete',
                        method: 'post',
                        baseURL:  process.env.VUE_APP_proxybaseurl + '',
                        data: {
                            id: id
                        }
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        },
    };
</script>
